import React from "react";
import { Button, Col, Form, Input, Row, Select } from "antd";

const { Option } = Select;
const UnitSearch = ({ onSearch, onReset, form, initialValues }) => {
  return (
    <Form form={form} onFinish={onSearch} initialValues={initialValues}>
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="param" rules={[{ required: false }]}>
            <Select placeholder="Search by..." defaultValue="unitSearch">
              <Option value="unitSearch">Title/Description</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="val" rules={[{ required: false }]}>
            <Input placeholder="Enter the search term..." />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default UnitSearch;
